import { useTranslation } from 'react-i18next'

import MoreIcon from '@wwt/shared/assets/icons/outline/more-1.svg'

import { NestedMenuItem } from '@/shared/ui/NestedMenu'
import { UnderDevelopment } from '@/shared/ui/UnderDevelopment'

import { ShareLink } from './ShareLink'

export const MoreOptions = () => {
	const { t } = useTranslation('header')

	return (
		<UnderDevelopment asChild>
			<ShareLink
				icon={<MoreIcon />}
				text={t('share.options.moreOptions')}
				data-wwt-id="header__share-more-options--button"
				onShare={() => {
					// TODO: implement more options
				}}
			/>
		</UnderDevelopment>
	)
}

export const MoreOptionsItem = () => {
	const { t } = useTranslation('header')

	return (
		<UnderDevelopment asChild>
			<NestedMenuItem
				to="more-options"
				data-wwt-id="header__burger-share-more-options--button"
				disabled
			>
				<MoreIcon />
				{t('share.options.moreOptions')}
			</NestedMenuItem>
		</UnderDevelopment>
	)
}
